import { mapState } from 'vuex';
export default {
  data() {
    return {
      resolutionOptions: [{
        value: '640x360',
        label: '640x360'
      }, {
        value: '848x480',
        label: '848x480'
      }, {
        value: '1280x720',
        label: '1280x720'
      }, {
        value: '1920x1080',
        label: '1920x1080'
      }],
      resolution: '1280x720',
      ratesOptions: [{
        value: '15',
        label: '15'
      }, {
        value: '30',
        label: '30',
        default: true
      }, {
        value: '60',
        label: '60'
      }],
      ratesValue: '30',
      bitrate: 2000,
      inputBitrateValue: 0,
      inputTimer: null
    };
  },
  computed: {
    ...mapState({
      State: state => state
    })
  },
  props: {
    statusInfo: {
      type: Object,
      default: function () {
        return {};
      }
    }
  },
  watch: {
    statusInfo: {
      immediate: true,
      handler: function (newVal) {
        if (newVal) {
          const {
            shareScreenResolution,
            shareScreenFrameRate,
            shareScreenBitrate
          } = newVal;
          shareScreenResolution ? this.resolution = shareScreenResolution : this.resolution = '1280x720';
          shareScreenFrameRate ? this.ratesValue = shareScreenFrameRate : this.ratesValue = '30';
          shareScreenBitrate ? this.bitrate = Number(shareScreenBitrate) : this.bitrate = 2000;
        }
      }
    }
  },
  methods: {
    // 分辨率+帧率联动码率
    updateBitrate() {
      const bitrates = new Map([['640x360-15', 800], ['640x360-30', 800], ['640x360-60', 1000], ['848x480-15', 610], ['848x480-30', 930], ['848x480-60', 930], ['1280x720-15', 1130], ['1280x720-30', 2000], ['1280x720-60', 3000], ['1920x1080-15', 2080], ['1920x1080-30', 3150], ['1920x1080-60', 4780]]);
      const key = `${this.resolution}-${this.ratesValue}`;
      this.bitrate = bitrates.get(key);
    },
    showDefault(item) {
      if (item.default) {
        return this.$t('setting.defaultBitrate');
      } else {
        return item.value;
      }
    },
    changeBitrateInputValue(val) {
      this.inputBitrateValue = val;
    },
    changeBirateVal(val) {
      // 判断是否为数字
      val = Number(val);
      if (isNaN(val)) {
        this.$message.warning(this.$t('partyInfo.inputNumber'));
        return;
      }
      if (val < 200 || val > 5000) {
        if (val > 5000) {
          this.inputBitrateValue = 5000;
          this.bitrate = 5000;
        } else {
          this.inputBitrateValue = 200;
          this.bitrate = 200;
        }
        this.$message.error(this.$t('setting.bitrateMessage'));
      } else {
        this.bitrate = val;
      }
    },
    asyncBitrateVal(val) {
      if (this.inputTimer) clearTimeout(this.inputTimer);
      // 判断是否为数字
      this.inputTimer = setTimeout(() => {
        // val = Number(val)
        // if (isNaN(val)) {
        // 	this.$message.warning(this.$t('partyInfo.inputNumber'))
        // 	return
        // }
        // if (val < 200 || val > 5000) {
        // 	this.$message.warning(this.$t('partyInfo.rightValue'))
        // 	return
        // }
        this.bitrate = val;
      }, 500);
    },
    submitSetting() {
      const bitVal = Number(this.bitrate);
      if (isNaN(bitVal)) {
        this.$message.warning(this.$t('partyInfo.inputNumber'));
        return;
      }
      if (bitVal < 200 || bitVal > 10000) {
        this.$message.warning(this.$t('partyInfo.rightValue'));
        return;
      }
      const params = {
        frameRate: this.ratesValue,
        bitrate: this.bitrate,
        resolution: this.resolution
      };
      this.axios.post(`/partyline-backend/partyAction/shareScreenSetting?partyCode=${this.State.partyCode}`, params).then(res => {
        if (res.data.errorCode === '0x0') {
          this.$emit('callback');
          this.$message.success(this.$t('galleryHost.setSuccess'));
        }
      });
    }
  }
};